import React from "react";
import { Link } from "react-router-dom";
import "./index.css";

const Pricing = () => {
  const pricingData = [
    {
      id: "p-1",
      status: "available",
      name: "Modern 2BR Apartment (City Center)",
      city: "Addis Ababa",
      totalSize: 98,
      noBedroom: 2,
      noBathroom: 2,
      type: "Apartment",
      description:
        "Bright 2-bedroom apartment with balcony, open-plan kitchen, and secure parking. Close to cafes, supermarkets, and main roads. Great for professionals or small families.",
      imageUrl:
        "https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?auto=format&fit=crop&w=1400&q=60",
      quantity: 2,
    },
    {
      id: "p-2",
      status: "available",
      name: "Family Home with Garden (Quiet Area)",
      city: "Addis Ababa",
      totalSize: 210,
      noBedroom: 4,
      noBathroom: 3,
      type: "House",
      description:
        "Spacious family home with a private garden, large living area, and parking space. Calm neighborhood with easy access to schools and shopping.",
      // ✅ CHANGED ONLY THIS IMAGE
      imageUrl:
        "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=60",
      quantity: 1,
    },
    {
      id: "p-3",
      status: "available",
      name: "Studio Apartment (Near Main Road)",
      city: "Addis Ababa",
      totalSize: 45,
      noBedroom: 1,
      noBathroom: 1,
      type: "Studio",
      description:
        "Compact studio with modern finishes, great natural light, and quick access to transport. Ideal for students or single professionals.",
      imageUrl:
        "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1400&q=60",
      quantity: 3,
    },
  ];

  const STRING_LIMIT = 150;

  return (
    <div className="pro-list-container">
      <div className="list-container pt-3">
        <div className="w-100 flex justify-content-start">
          <h1 className="text-dark fw-medium">Properties</h1>
        </div>

        <p className="text-info">
          {pricingData.length}{" "}
          {pricingData.length < 2 ? "Property" : "Properties"}
        </p>

        {pricingData.map((p) => (
          <div className="row pro-list-card" key={p.id}>
            <div className="col-md-12 col-lg-3 col-xl-3 mb-4 mb-lg-0">
              <div className="bg-image hover-zoom ripple rounded ripple-surface">
                <img
                  src={p.imageUrl}
                  className="w-100"
                  alt={p.name}
                  style={{ maxHeight: 220, objectFit: "cover" }}
                />
                {/* <Link to={`/property/${p.id}`}>
                  <div className="hover-overlay">
                    <div className="mask"></div>
                  </div>
                </Link> */}
              </div>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-6">
              <span className="badge badge-dark rounded-pill d-inline px-2 mb-3">
                {p.status}
              </span>

              <h4 className="mt-2 fw-bolder">{p.name}</h4>

              <div className="flex">
                <i className="fa-solid fa-location-dot mr-2"></i>
                <h6 className="">{p.city}</h6>
              </div>

              <div className="flex">
                <div className="mt-1 mb-0 text-muted mx-1">
                  <span>
                    <i className="fa-solid fa-ruler mr-2"></i>
                    {p.totalSize} Sq m
                  </span>
                </div>
                <div className="mt-1 mb-0 text-muted mx-1">
                  <span>
                    <i className="fa-solid fa-bed mr-2"></i>
                    {p.noBedroom}
                  </span>
                </div>
                <div className="mt-1 mb-0 text-muted mx-1">
                  <span>
                    <i className="fa-solid fa-bath mr-2"></i>
                    {p.noBathroom}
                  </span>
                </div>
              </div>

              <p className="text-secondary">{p.type}</p>

              <h4>Description</h4>
              <p className="mb-4 mb-md-0 w100">
                {p.description.length > STRING_LIMIT
                  ? p.description.slice(0, STRING_LIMIT) + "..."
                  : p.description}
              </p>
            </div>

            <div className="col-md-6 col-lg-3 col-xl-3 border-sm-start-none border-start justify-content-between h-100">
              <div>
                <h6 className="text-info">Remaining {p.quantity}</h6>
              </div>

              <div className="d-flex flex-column mt-4">
                {/* <Link to={`/property/${p.id}`}>
                  <button className="btn btn-primary btn-sm" type="button">
                    Detail
                  </button>
                </Link> */}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Pricing;
